webpackJsonp([11],{

/***/ "0Nxs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





__WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('de');
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
// Vue.use(Axios);
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common = { 'Content-Encoding': 'gzip' };
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    dogs: [],
    teams: [], tempteams: [],
    reports: [],
    footermenu: [],
    headermenu: [],
    dog: {},
    events: [],
    news: [], tempnews: [],
    page: {},
    dogfilter: [],
    doginfo: {},
    sponsors: [],
    helps: [],
    bigfont: false

  },
  mutations: {
    switchfont: function switchfont(state) {
      state.bigfont = !state.bigfont;
    },
    addToFilter: function addToFilter(state, id) {
      // state.dogfilter = [];
      state.dogfilter = [id];
    },
    removeFromFilter: function removeFromFilter(state, id) {
      state.dogfilter.splice(state.dogfilter.indexOf(id), 1);
    },
    getDog: function getDog(state, slug) {
      var d = state.dogs.filter(function (d) {
        return d.slug === slug;
      });
      state.dog = d[0];
      if (state.dog) {
        state.dog.index = state.dogs.indexOf(d[0]);
      }
    },
    emptyFilter: function emptyFilter(state, id) {
      state.dogfilter = [];
    },
    saveDogs: function saveDogs(state, data) {
      state.dogs = data;
    },
    saveSponsors: function saveSponsors(state, data) {
      state.sponsors = data[0];
    },
    saveHelps: function saveHelps(state, data) {
      state.helps = data;
    },
    saveFootermenu: function saveFootermenu(state, data) {
      state.footermenu = data;
    },
    saveHeadermenu: function saveHeadermenu(state, data) {
      state.headermenu = data;
    },
    saveNews: function saveNews(state, data) {

      state.news = state.tempnews;
    },
    addNews: function addNews(state, data, page) {
      data.forEach(function (ev) {
        ev.type = 'news';
        ev.big = ev.acf.big;
        ev.datum = __WEBPACK_IMPORTED_MODULE_3_moment___default()(ev.date).format('YYYYMMDD');
      });

      data.forEach(function (d) {
        return state.tempnews.push(d);
      });
    },
    emptyNews: function emptyNews(state) {
      state.tempnews = [];
    },
    saveEvents: function saveEvents(state, data) {
      data.forEach(function (ev) {
        ev.big = ev.acf.big;
        ev.type = 'event';
        ev.datum = ev.acf.datum;
      });
      state.events = data;
    },
    setDogPage: function setDogPage(state, data) {
      state.dog = data[0];
    },
    savePage: function savePage(state, data) {
      state.page = data[0];
    },
    saveDogInfo: function saveDogInfo(state, data) {
      state.doginfo = data[0];
    },
    saveReports: function saveReports(state, data) {
      data.forEach(function (team) {
        if (team.acf.teamberichte) {
          team.acf.teamberichte.forEach(function (rep, index) {
            rep.team = team.title.rendered;
            rep.teamslug = team.slug;
            rep.type = 'report';
            rep.nummer = index + 1;
            rep.teambild = team.better_featured_image.media_details.sizes.medium.source_url;
            state.reports.push(rep);
          });
        }
      });
    },
    saveTeams: function saveTeams(state) {
      state.teams = state.tempteams;
    },
    addTeams: function addTeams(state, data, page) {
      data.forEach(function (d) {
        return state.tempteams.push(d);
      });
    },
    emptyTeams: function emptyTeams(state) {
      state.tempteams = [];
    }
  },

  actions: {
    getTeams: function getTeams(store) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/wp-json/wp/v2/teams?orderby=menu_order&order=asc&per_page=99&page=' + page).then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveReports', response.data);
        if (page === 1) store.commit('emptyTeams');
        store.commit('addTeams', response.data, page);
        console.log(response);
        response.data.length % 99 === 0 ? store.dispatch('getTeams', page + 1) : store.commit('saveTeams', response.data);
        // store.commit('saveTeams', response.data);
      }).catch(function (error) {
        if (store.state.tempteams.length > 0) store.commit('saveTeams');
      });
    },
    getDogs: function getDogs(store) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/wp-json/wp/v2/dogs?orderby=menu_order&order=asc&per_page=99').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveDogs', response.data);
      });
    },
    getPageBySlug: function getPageBySlug(store, slug) {
      store.state.page = {};
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/wp-json/wp/v2/pages?slug=' + slug).then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('savePage', response.data);
      });
    },
    getDogInfoBySlug: function getDogInfoBySlug(store, slug) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/wp-json/wp/v2/pages?slug=' + slug).then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveDogInfo', response.data);
      });
    },
    getDogBySlug: function getDogBySlug(store, slug) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/wp-json/wp/v2/dogs?slug=' + slug).then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('savePage', response.data);
      });
    },
    getEvents: function getEvents(store) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/wp-json/wp/v2/events?per_page=99').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveEvents', response.data);
      });
    },
    getSponsors: function getSponsors(store) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/wp-json/wp/v2/pages?slug=sponsoren').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveSponsors', response.data);
      });
    },
    getNews: function getNews(store) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/wp-json/wp/v2/posts?per_page=99&page=' + page).then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        if (page === 1) store.commit('emptyNews');
        store.commit('addNews', response.data, page);
        response.data.length % 99 === 0 ? store.dispatch('getNews', page + 1) : store.commit('saveNews', response.data);
      }).catch(function (error) {
        if (store.state.tempnews.length > 0) store.commit('saveNews');
      });
    },
    getHelps: function getHelps(store) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/wp-json/wp/v2/spenden?orderby=menu_order&order=asc&per_page=99').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveHelps', response.data);
      });
    },
    // getMenus: function (store) {
    //     Axios.get('/wp-json/wp-api-menus/v2/menus/').then(function (response) {
    //         // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
    //         store.commit('saveMenus', response.data);
    //
    //     });
    // },
    getFootermenu: function getFootermenu(store) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/wp-json/navi/footermenu').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveFootermenu', response.data);
      });
    },
    getHeadermenu: function getHeadermenu(store) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/wp-json/navi/headermenu').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveHeadermenu', response.data);
      });
    }

  }

}));

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73b5115c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("xnwC");
function injectStyle (ssrContext) {
  __webpack_require__("y2xs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73b5115c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73b5115c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MFxz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_index_js__ = __webpack_require__("msXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_touch_events__ = __webpack_require__("ufW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_touch_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_touch_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_meta__);












/* tracker methods like "setCustomDimension" should be called before "trackPageView" */

// router.afterEach(function (to, from) {
//     if (from.name !== null) {
//         _paq.push(['setDocumentTitle', to.name])
//         _paq.push(['setCustomUrl', to.path])
//         _paq.push(['trackPageView']);
//     }
// })

var $ = __webpack_require__("7t+N");
__webpack_require__("tgCg");
window.jQuery = $;
__webpack_require__("0Nxs");
__webpack_require__("MFxz");

var assign = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function assign(to) {
    for (var s = 1; s < arguments.length; s += 1) {
        var from = arguments[s];
        for (var key in from) {
            to[key] = from[key];
        }
    }
    return to;
};

__WEBPACK_IMPORTED_MODULE_7_moment___default.a.locale('de');
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue2_touch_events___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_6__mixins_index_js__["e" /* scrollHandler */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_6__mixins_index_js__["c" /* offset */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_6__mixins_index_js__["d" /* resizeHandler */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_6__mixins_index_js__["b" /* customFunctions */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_6__mixins_index_js__["a" /* connectionCheck */]);

var vueSmoothScroll = __webpack_require__("KLw7");
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(vueSmoothScroll);

var session = window.sessionStorage,
    storage = window.localStorage,
    log = console && console.log || function () {};
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.debug = Object({"NODE_ENV":"production"}).DEBUG_MODE;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]);
    }
});

/***/ }),

/***/ "Vak5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "app/img/ADI-accredited-logo_weiss.06f73f5.png";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{ path: '/', redirect: '/start' }, {
        path: '/start',
        name: 'Start',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'start' }
    }, {
        path: '/teams',
        name: 'Teams',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'teams' }

    }, {
        path: '/teams/:slug',
        name: 'Teambericht',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'teams' }
    }, {
        path: '/assistenzhunde/:slug/teams',
        name: 'Hundeteams',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'hunde', filter: true }
    }, {
        path: '/assistenzhunde/:slug',
        name: 'Hunde',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'hunde' }
    }, {
        path: '/assistenzhunde',
        name: 'AlleHunde',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'hunde' }
    }, {
        path: '/news',
        name: 'News',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'news' }
    }, {
        path: '/news/:slug',
        name: 'JumpToNews',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'news', 'jump': true }
    }, {
        path: '/events/:slug',
        name: 'JumpToEvent',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'news', 'jump': true }
    }, {
        path: '/helfen',
        name: 'Helfen1',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'helfen' }
    }, {
        path: '/helfen/finanziell',
        name: 'Helfen21',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'helfen', 'cat': 'finanziell', 'selector': '#helps' }
    }, {
        path: '/helfen/materiell',
        name: 'Helfen22',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'helfen', 'cat': 'materiell', 'selector': '#helps' }
    }, {
        path: '/helfen/:slug',
        name: 'Helfen3',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'helfen', 'selector': '#help' }
    }, {
        path: '/:slug',
        name: 'Seite',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'seite' }
    }, {
        path: '/:cat/:slug',
        name: 'Unterseite',
        component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        meta: { 'view': 'seite' }
    }],
    mode:  true ? 'history' : 'hash',
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {

        if (savedPosition) {

            return savedPosition;
        }

        if (to.meta.selector) {

            return {
                selector: to.meta.selector,
                offset: { x: 0, y: 100 }
            };
        }
        if (to.meta.jump) {
            console.log(to);
            return {
                selector: chronik,
                offset: { x: 0, y: 100 }
            };
        } else if (to.hash) {
            // return {
            //
            //     selector: to.hash,
            //     offset:  new Promise((resolve, reject) => {
            //         setTimeout(() => {
            //             resolve({x: 0, y: 50})
            //         }, 5000)
            //     })
            // }

            return {
                selector: to.hash,
                offset: { x: 0, y: 100 }
            };
        } else {
            return { x: 0, y: 0 };
        }
    }
}));

/***/ }),

/***/ "msXN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return scrollHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customFunctions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return connectionCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return resizeHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return offset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_moment__);



var scrollHandler = {
    data: function data() {
        return {
            scrollPosition: 0

        };
    },
    components: {},
    methods: {
        handleScroll: function handleScroll() {
            window.requestAnimationFrame(function () {
                this.scrollPosition = window.scrollY;
            }.bind(this));
        },
        focusMessage: function focusMessage() {
            jQuery('#message').focus();
        }
    },
    destroyed: function destroyed() {
        window.removeEventListener('DOMContentLoaded', this.handleScroll);
    },

    created: function created() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    },
    watch: {}
};

var customFunctions = {

    methods: {
        getBackground: function getBackground(t) {
            if (t.better_featured_image.media_details.sizes.medium_large) {
                return "url('" + t.better_featured_image.media_details.sizes.medium_large.source_url + "')";
            } else if (t.better_featured_image.media_details.sizes.medium) return "url('" + t.better_featured_image.media_details.sizes.medium.source_url + "')";else {
                return "url('" + t.better_featured_image.source_url + "')";
            }
        },
        checkLink: function checkLink(link) {
            return link.match('(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])') !== null;
        },

        shortLink: function shortLink(link) {
            return link.replace(/^.*\/\/[^\/]+/, '');
        },
        neuerBericht: function neuerBericht(reps, months) {
            var dates = [];
            if (reps.length > 0) {
                reps.map(function (rep) {
                    var diff = __WEBPACK_IMPORTED_MODULE_1_moment_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment_moment___default()(rep.datum), 'months');
                    dates.push(diff);
                });
                return Math.min.apply(Math, dates) < months;
            }
            return false;
        },
        reportIstNeu: function reportIstNeu(item, months) {
            var mdiff = __WEBPACK_IMPORTED_MODULE_1_moment_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment_moment___default()(item.datum), 'months');
            return mdiff < months;
        },
        getDay: function getDay(datum) {
            return __WEBPACK_IMPORTED_MODULE_1_moment_moment___default()(datum).format('DD');
        },
        getMonth: function getMonth(datum, length) {
            return length === 'long' ? __WEBPACK_IMPORTED_MODULE_1_moment_moment___default()(datum).format('MMM') : __WEBPACK_IMPORTED_MODULE_1_moment_moment___default()(datum).format('MM');
        },
        getYear: function getYear(datum) {
            return __WEBPACK_IMPORTED_MODULE_1_moment_moment___default()(datum).format('YY');
        },
        arrayFromObject: function arrayFromObject(obj) {
            var arr = [];
            for (var i in obj) {
                arr.push(obj[i]);
            }
            return arr;
        },
        groupBy: function groupBy(list, fn) {
            var groups = {};
            for (var i = 0; i < list.length; i++) {
                var group = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(fn(list[i]));
                if (group in groups) {
                    groups[group].push(list[i]);
                } else {
                    groups[group] = [list[i]];
                }
            }
            return this.arrayFromObject(groups);
        },
        biggerRightbox: function biggerRightbox() {
            jQuery('#rightbox').css('height', 'auto');
            jQuery('.morebutton').fadeOut(100);
        },
        htmlEncode: function htmlEncode(value) {
            return jQuery('<div/>').html(value).text();
        }
    },
    directives: {
        adjustheight: function adjustheight(el) {
            setTimeout(function () {
                var leftbox = jQuery('#leftbox').height();
                var rightbox = jQuery('#rightbox').height();
                if (rightbox - leftbox > 150) {
                    jQuery(el).css('height', leftbox);
                    jQuery('.morebutton').show();
                }
            }, 500);
        }
    }
};

var connectionCheck = {
    data: function data() {
        return {
            offline: false
        };
    },
    created: function created() {
        window.addEventListener('online', this.networkChange);
        window.addEventListener('offline', this.networkChange);
    },

    methods: {
        networkChange: function networkChange(e) {
            this.offline = e.type == "offline";
        }
    }
};

var resizeHandler = {
    data: function data() {
        return {
            scrHeight: 0,
            windowWidth: 0
        };
    },

    methods: {
        getHeight: function getHeight() {
            this.scrHeight = window.innerHeight;
            this.windowWidth = jQuery(window).width();
            // console.log(this.scrHeight)
        }
    },
    destroyed: function destroyed() {
        window.removeEventListener('resize', this.getHeight);
    },

    created: function created() {
        this.getHeight();
        window.addEventListener('resize', this.getHeight, { passive: true });
    }

};

var offset = {
    data: function data() {
        return {
            offsetclass: false
        };
    },
    updated: function updated() {},
    mounted: function mounted() {
        this.offsetclass = false;
        this.$nextTick(function () {
            setTimeout(function () {
                this.offsetclass = true;
            }.bind(this), 500);
        });
    }
};

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  store: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */],
  name: 'app',

  components: {
    Top: function Top() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "vO+y"));
    },
    Foot: function Foot() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, "o8L3"));
    },
    Start: function Start() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "w95W"));
    },
    Hunde: function Hunde() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "i25P"));
    },
    Teams: function Teams() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "aoOz"));
    },
    Seite: function Seite() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "k/m4"));
    },
    News: function News() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "QEeC"));
    },
    Help: function Help() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "ZCnB"));
    },
    Sponsoren: function Sponsoren() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "Ox+T"));
    },
    Extranav: function Extranav() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "O6Uk"));
    }

  },
  created: function created() {
    this.getPage();
    if (!(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.dogs.length > 0)) __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('getDogs');
    if (!(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.footermenu.length > 0)) __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('getFootermenu');
    if (!(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.headermenu.length > 0)) __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('getHeadermenu');
    if (!(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.teams.length > 0)) __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('getTeams');
    if (!(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.sponsors.length > 0)) __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('getSponsors');
  },
  methods: {
    getPage: function getPage() {
      switch (this.view) {

        case 'start':
          __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('getPageBySlug', 'start');
          break;

        case 'seite':
          __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('getPageBySlug', this.slug);
          break;
        case 'hunde':

          __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('getPageBySlug', 'assistenzhunde');
          break;
        default:
          if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.page.slug !== this.$route.meta.view) {
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('getPageBySlug', this.$route.meta.view);
          }
      }
    },
    getLogoPos: function getLogoPos() {
      var pos = this.scrollPosition * -2 - 60;
      return pos + 'px';
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapState({
    page: 'page',
    dog: 'dog',
    team: function team() {
      var _this = this;

      var team = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.teams.filter(function (d) {
        return d.slug === _this.$route.params.slug;
      });
      this.index = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.teams.indexOf(team[0]);
      return team[0];
    },

    bigfont: 'bigfont',
    sitechange: function sitechange() {
      if (this.$route.meta.view === 'helfen') return 'help';else if (this.$route.params.slug) return this.$route.params.slug;else return this.$route.name;
    },
    slug: function slug() {
      return this.$route.params.slug;
    },
    footermenu: function footermenu() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.footermenu;
    },
    headermenu: function headermenu() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.headermenu;
    },
    view: function view() {
      return this.$route.meta.view;
    },
    rname: function rname() {
      return this.$route.meta.rname;
    },
    online: function online() {
      return VueOnline.isOnline;
    },
    title: function title() {
      var rawtitle = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.page._aioseop_title ? __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.page._aioseop_title : __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.page.title ? __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.page.title.rendered : '';

      return rawtitle == undefined ? '' : this.htmlEncode(rawtitle);
    },
    description: function description() {
      if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.page.meta) {
        return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.page.meta['_aioseop_description'] ? __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.page.meta._aioseop_description[0] : '';
      }
    }
  }),
  watch: {
    // bigfont() {
    //     this.bigfont ? jQuery('#app').addClass('big') : jQuery('#app').css('font-size', '16px')
    // },
    $route: function $route() {
      this.getPage();
    },

    // dogs() {
    //     store.commit('getDog', this.$route.params.slug)
    // },
    slug: function slug() {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('getDog', this.$route.params.slug);
    }
  },
  metaInfo: function metaInfo() {
    return {
      title: this.title ? this.title === undefined ? '' : this.title : '',

      titleTemplate: function titleTemplate(titleChunk) {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? titleChunk + ' - Partnerhunde \xD6sterreich' : 'Partnerhunde Österreich';
      },
      meta: [{ charset: 'utf-8' }, { vmid: "description", name: 'description', content: this.description }, { vmid: "author", name: 'author', content: 'Partner Hunde Österreich' }],
      link: [{ rel: 'favicon', href: '/favicon.png' }]

    };
  }
});

/***/ }),

/***/ "xnwC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'big':_vm.bigfont},attrs:{"id":"app"}},[_c('Top',{attrs:{"menu":_vm.headermenu}}),_vm._v(" "),_c('div',{staticClass:"head",class:{'active':_vm.scrollPosition>30}},[_c('div',{staticClass:"headline"},[(_vm.page)?_c('h1',{staticClass:"inherit"},[_c('transition',{attrs:{"name":"delayfade"}},[(_vm.page.acf)?_c('span',[(_vm.team&&_vm.view==='teams')?_c('span',{key:"1",domProps:{"innerHTML":_vm._s('Teamberichte - '+_vm.team.title.rendered)}}):(_vm.dog&&_vm.view==='hunde')?_c('span',{key:"3"},[(_vm.dog.title)?_c('span',{domProps:{"innerHTML":_vm._s('Assistenzhunde - '+_vm.dog.title.rendered)}}):_vm._e()]):(_vm.page.acf.uberschrift)?_c('span',{key:"2",domProps:{"innerHTML":_vm._s(_vm.page.acf.uberschrift)}}):_c('span',{key:"4",domProps:{"innerHTML":_vm._s(_vm.page.title.rendered)}})]):_vm._e()])],1):_vm._e(),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(_vm.dog)?_c('div',{staticClass:"headline",staticStyle:{"padding-top":"0"}},[(_vm.dog.acf&&_vm.view==='hunde')?_c('Extranav',{attrs:{"blocks":_vm.dog.acf.layout}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('div',{staticClass:"headline",staticStyle:{"padding-top":"0"}},[(_vm.page.acf&&_vm.view==='seite')?_c('Extranav',{attrs:{"blocks":_vm.page.acf.layout}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"wrap"},[(_vm.offline)?_c('div',[_vm._m(1)]):_vm._e(),_vm._v(" "),_c('transition-group',{attrs:{"name":"delayfade","mode":"out-in"}},[_c('div',{key:_vm.sitechange,staticClass:"content"},[(_vm.view==='start')?_c('Start',{attrs:{"page":_vm.page}}):_vm._e(),_vm._v(" "),(_vm.view==='hunde')?_c('Hunde'):_vm._e(),_vm._v(" "),(_vm.view==='teams')?_c('Teams'):_vm._e(),_vm._v(" "),(_vm.view==='seite')?_c('Seite',{attrs:{"page":_vm.page}}):_vm._e(),_vm._v(" "),(_vm.view==='news')?_c('News',{attrs:{"page":_vm.page}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"content"},[(_vm.view==='helfen')?_c('Help'):_vm._e()],1),_vm._v(" "),_c('transition-group',{attrs:{"name":"latefade","mode":"out-in","appear":""}},[_c('div',{key:_vm.sitechange},[(_vm.view!=='helfen')?_c('Sponsoren',{attrs:{"page":_vm.page}}):_vm._e()],1),_vm._v(" "),_c('footer',{key:_vm.sitechange},[_c('Foot',{attrs:{"menu":_vm.footermenu}})],1)])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"ati",attrs:{"target":"_blank","href":"https://www.assistancedogsinternational.org/"}},[_c('img',{attrs:{"src":__webpack_require__("Vak5"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('strong',[_vm._v("Achtung!")]),_vm._v(" Ihre Internet-Verbindung ist unterbrochen!\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y2xs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// app/js/app.17562c194dd34881212b.js